"use client";
import {
  chip_default
} from "./chunk-NAV3ZXLI.mjs";
import {
  useChip
} from "./chunk-P5JPZ5W3.mjs";
export {
  chip_default as Chip,
  useChip
};
